import { inject } from 'tsyringe'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { containerScoped } from '~/decorators/dependency-container'
import { ManagerApplicationForm } from '~/models/user/types'
import { Schema } from '~/models/form/types'
import { toSnakeCase } from '~/utils/snake-case'

@containerScoped()
export default class ManagerApplicationService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  applicationFormSchema(): Promise<{ schema: Schema }> {
    return this.requestBuilder.request('GET', '/api/dealers/register/').send()
  }

  submitApplication(values: ManagerApplicationForm) {
    return this.requestBuilder
      .request('POST', '/api/dealers/register/')
      .data(toSnakeCase(values))
      .send()
  }
}
